import React from 'react';
import { color as palette } from "@/constants/palette";

function RightChevron() {
  return (
    <svg aria-hidden="true" focusable="false"
      xmlns='http://www.w3.org/2000/svg'
      width='38'
      height='38'
      viewBox='0 0 38 38'
      fill='none'
    >
      <rect
        width='38'
        height='38'
        rx='19'
        transform='matrix(-1 0 0 1 38 0)'
        fill={palette.heading}
        fillOpacity='0.2'
      />
      <path
        d='M16 11L24 19L16 27'
        stroke='white'
        strokeWidth='2.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}

export default RightChevron;
